export default function FeedbackMetricSummary({ items = [] }) {
  return (
    <dl className="av-feedback-metric-summary">
      {items.map(item => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
